import { useRef, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { ValidationOtp } from "../../../../theme/Component/ValidationOTP/ValidationOtp";

interface Props {
    exportMap: Function;
    procedure: any;
    pushProps?: Function;
    pushInfo?: Function;
}

interface Resp {
    Obs: string;
    Approve: string;
    Decline: string;
}

export const BPM001 = ({ exportMap, pushInfo, pushProps }: Props) => {

    const [response, setResponse] = useState<Resp>({
        Approve: "",
        Decline: "",
        Obs: ""
    })

    const onExportMap = () => {
        if (pushProps) {
            pushProps({
                Approve: response.Approve,
                Decline: response.Decline,
            })
        }
        if (pushInfo) {
            pushInfo(response.Obs)
        }
        exportMap(response)
    }

    const otpValidator = useRef<any>(null);

    const saveInfo = () => {
        if (otpValidator.current) {
            otpValidator.current.openOTPModal("Validacion de Identidad")
        }
    }

    const handleApprove = () => {
        setResponse({ ...response, "Approve": "true", "Decline": "false" })
        saveInfo();
    }

    const handleDecline = () => {
        setResponse({ ...response, "Approve": "false", "Decline": "true" })
        saveInfo();
    }

    return (
        <>
            <div className="row d-flex justify-content-between">
                <div className="col-md-12 mb-2">
                    <label>Observaciones</label>
                    <textarea className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-checkbox-circle-line" eventClick={() => { handleApprove() }} >Aprobar</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-close-circle-line" eventClick={() => { handleDecline() }} >Rechazar</BasicButton>
                </div>

                <div className="col-md-12">
                    <ValidationOtp onValidate={onExportMap} ref={otpValidator} />
                </div>
            </div>

        </>
    );
};